<div class="buttons-container">
  @if (
    {
      isCapturingVideo: isCapturingVideo$ | async,
      isAudioMuted: isAudioMuted$ | async,
    };
    as state
  ) {
    <button
      mat-icon-button
      color="black"
      (click)="toggleVideo()"
      [disabled]="!isVideoStarted"
    >
      @if (state.isCapturingVideo) {
        <mat-icon svgIcon="video-on"> </mat-icon>
      }
      @if (!state.isCapturingVideo) {
        <mat-icon svgIcon="video-off"> </mat-icon>
      }
    </button>
    <div class="audio-buttons">
      @if (isIODeviceListOpen) {
        <div class="media-list" #mediaInput>
          <span class="header">Select a Microphone</span>
          <div class="mic-container">
            @for (microphone of microphoneList; track microphone) {
              <div class="media-button-container">
                <button
                  mat-button
                  class="media-button"
                  (click)="setMicrophoneDevice($event, microphone.deviceId)"
                >
                  {{ microphone.label }}
                </button>
                @if (microphone.deviceId === activeMicrophoneDevice) {
                  <mat-icon color="black">check</mat-icon>
                }
              </div>
            }
          </div>
          <span class="header">Select a Speaker</span>
          <div class="speaker-container">
            @for (speaker of speakerList; track speaker) {
              <div class="media-button-container">
                <button
                  mat-button
                  class="media-button"
                  (click)="setSpeakerDevice($event, speaker.deviceId)"
                >
                  {{ speaker.label }}
                </button>
                @if (speaker.deviceId === activeSpeakerDevice) {
                  <mat-icon color="black">check</mat-icon>
                }
              </div>
            }
          </div>
        </div>
      }
      <button
        mat-icon-button
        color="black"
        (click)="toggleAudio()"
        [disabled]="!isAudioStarted"
      >
        @if (state.isAudioMuted) {
          <mat-icon>mic_off</mat-icon>
        }
        @if (!state.isAudioMuted) {
          <mat-icon>mic</mat-icon>
        }
      </button>
      <button
        mat-icon-button
        color="grey"
        (click)="toggleIOList($event)"
        [disabled]="!isAudioStarted"
        class="expand-button"
      >
        @if (!isIODeviceListOpen) {
          <mat-icon>expand_more</mat-icon>
        }
        @if (isIODeviceListOpen) {
          <mat-icon>expand_less</mat-icon>
        }
      </button>
    </div>
  }

  <button mat-mini-fab color="warn" (click)="leaveCall()">
    <mat-icon>call_end</mat-icon>
  </button>
</div>
